module.exports = __webpack_public_path__ + "static/media/sathi-guff.addec768.png";